

<div>
  <button *ngIf="token" class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
  </div>
<div class="container-fluid">
  <div class="row">

    <div class="col info-padding">
      <h2 class="heading">FAQ</h2>
      <mat-accordion *ngFor="let x of faqList">

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="icon-question"></i> {{x?.questionText}}
            </mat-panel-title>

          </mat-expansion-panel-header>


          <p>{{x?.detail}}</p>


        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
